/* eslint-disDigitalAssetsable react/jsx-no-constructed-context-values */
import { createContext } from 'react';

const BridgeContext = createContext({});

export default BridgeContext;
